import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// Last, after every component stylesheet App pulls in - see the cascade
// note at the top of mobile.css.
import './style/mobile.css';
import { initLayoutMode } from './utils/layoutMode';

// Before the first render, so the first paint is already laid out for the
// right device.
initLayoutMode();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
